import { TimeUtils } from "../utils/TimeUtils";
import { LanguageData, LanguageMetaData } from "./LanguageMetaData";

/**
 * Parser class used to parse the <code>XML</code> file with language definitions.
 */
export class TextsParser {
    private static REGEXP_NEWLINES: RegExp = /\\n/g;
    private static REGEXP_AMP: RegExp = /&amp;/g;

    public static jsonToMap(obj: any, isCaseSensitive: boolean): Map<string, string> {
        let result: Map<string, string> = new Map<string, string>();

        if (obj) {
            for (let language in obj) {
                if (obj.hasOwnProperty(language)) {
                    let languageDefinitions = obj[language];
                    for (let key in languageDefinitions) {
                        if (languageDefinitions.hasOwnProperty(key)) {
                            let textId: string = isCaseSensitive ? key : key.toLowerCase();
                            let text: string = TextsParser.formatText(languageDefinitions[key]);
                            result.set(textId, text);
                        }
                    }
                }
            }
        }

        return result;
    }

    /**
     * Parse the version of the language file.
     *
     * @param json Language file with all definitions for the localization package.
     *
     * @return Version of the language file.
     */

    public static parseVersionNo(json: any | LanguageData): string {
        let versionNo: string;

        const metaData: LanguageMetaData = json["@metadata"];
        if (metaData) {
            versionNo = metaData.versionNo;
        }

        return versionNo;
    }

    /**
     * Parse the deploy time of the language file.
     *
     * @param json Language file with all definitions for the localization package.
     *
     * @return Formatted <code>String</code> representing the time when the language file was generated.
     */
    public static parseDeployTime(json: any | LanguageData): string {
        let textVersion: string;

        const metaData: LanguageMetaData = json["@metadata"];
        if (metaData) {
            let timestamp = metaData.deployTime;
            // tslint:disable-next-line:radix
            textVersion = TimeUtils.unixToHumanTime(parseInt(timestamp));
        }
        return textVersion;
    }

    public static parseBranch(json: any | LanguageData): string {
        let branch: string;

        const metaData: LanguageMetaData = json["@metadata"];
        if (metaData) {
            branch = metaData.branch;
        }
        return branch;
    }

    /**
     * @private
     */
    public static formatText(text: string): string {
        text = text.replace(TextsParser.REGEXP_AMP, "&");
        text = text.replace(TextsParser.REGEXP_NEWLINES, "\n");
        return text;
    }
}
